import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

// Updated data to include News Management
const approvalHierarchies = [
    {
        id: 1,
        module: 'Offer Management',
        approvers: [
            { name: 'John Doe', role: 'Manager', level: 1 },
            { name: 'Jane Smith', role: 'Director', level: 2 },
        ]
    },
    {
        id: 2,
        module: 'News Management',
        approvers: [
            { name: 'Sarah Johnson', role: 'Content Manager', level: 1 },
            { name: 'Michael Brown', role: 'IT Director', level: 2 },
        ]
    },
    {
        id: 3,
        module: 'Vehicle Management',
        approvers: [
            { name: 'Samuel Lee', role: 'Supervisor', level: 1 },
            { name: 'Lisa Wong', role: 'CEO', level: 2 },
        ]
    }
];

const ApprovalHierarchyTable = () => {
    const navigate = useNavigate();

    const handleEdit = (id) => {
        navigate(`/user-approvals/edit-hierarchy/${id}`);
    };

    const getModuleBadge = (module) => {
        const badgeMapping = {
            'Offer Management': 'primary',
            'News Management': 'info',
            'Vehicle Management': 'success'
        };
        return <Badge bg={badgeMapping[module] || 'secondary'}>{module}</Badge>;
    };

    return (
        <Table responsive striped bordered hover className='text-center'>
            <thead>
                <tr>
                    <th>Sr. No</th>
                    <th>Module</th>
                    <th>Approvers</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {approvalHierarchies.map((hierarchy, index) => (
                    <tr key={hierarchy.id}>
                        <td>{index + 1}</td>
                        <td>{getModuleBadge(hierarchy.module)}</td>
                        <td>
                            <div className="d-flex flex-column align-items-center">
                                {hierarchy.approvers.map((approver, idx) => (
                                    <div key={idx} className="mb-1">
                                        <Badge bg="outline-dark" className="me-2">
                                            Level {approver.level}
                                        </Badge>
                                        <strong>{approver.name}</strong> ({approver.role})
                                    </div>
                                ))}
                            </div>
                        </td>
                        <td>
                            <Button variant="warning" size="sm" onClick={() => handleEdit(hierarchy.id)}>
                                Edit Hierarchy
                            </Button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default ApprovalHierarchyTable;
